var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    clipPath: "url(#clip0_2437_16982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8813 -0.000244141H5.11826C2.29139 -0.000244141 -0.000244141 2.29139 -0.000244141 5.11826V18.8813C-0.000244141 21.7081 2.29139 23.9998 5.11826 23.9998H18.8813C21.7081 23.9998 23.9998 21.7081 23.9998 18.8813V5.11826C23.9998 2.29139 21.7081 -0.000244141 18.8813 -0.000244141Z",
    fill: "#0A93E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2989 8.3605C18.7727 8.59345 18.2146 8.74631 17.6431 8.814C18.2407 8.45542 18.6977 7.88943 18.9087 7.21798C18.3433 7.55304 17.7252 7.7896 17.0806 7.91756C16.6857 7.49356 16.1721 7.19843 15.6069 7.07068C15.0417 6.94293 14.4511 6.98849 13.9121 7.2014C13.3732 7.41432 12.911 7.78471 12.5857 8.26426C12.2604 8.74381 12.0872 9.31026 12.0887 9.88972C12.088 10.111 12.1128 10.3315 12.1625 10.5471C11.0158 10.4896 9.89404 10.1917 8.86993 9.67266C7.84582 9.15364 6.94226 8.42512 6.21787 7.53437C5.84732 8.16935 5.73338 8.92191 5.89936 9.63812C6.06534 10.3543 6.4987 10.9801 7.1108 11.3873C6.6522 11.3729 6.20373 11.2488 5.80305 11.0252V11.0604C5.80305 12.4595 6.79792 13.6267 8.11622 13.8903C7.69212 14.006 7.24712 14.0229 6.8155 13.9395C6.99985 14.5123 7.35841 15.0133 7.84115 15.3725C8.32389 15.7317 8.90673 15.9313 9.50834 15.9433C8.90997 16.4137 8.2247 16.7614 7.49177 16.9665C6.75883 17.1716 5.99264 17.2301 5.23706 17.1386C6.51317 17.9577 8.02833 18.4323 9.6595 18.4323C14.9678 18.4323 17.8681 14.038 17.8681 10.2237C17.8681 10.1007 17.8681 9.97761 17.8611 9.85105C18.4235 9.44678 18.9157 8.93704 19.3024 8.3605H19.2989Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_16982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fc3b6703e54e0eea19405e94747a5553.svg";
export { ForwardRef as ReactComponent };